import axios from 'axios';

type ProjectMode = 'development' | 'production';
export const projectMode: ProjectMode = 'development';

export default axios.create({
    baseURL: 'https://hidden-reaches-94337.herokuapp.com/api',
    // baseURL: 'http://157.24.105.105:8080/api',
    // https://hidden-reaches-94337.herokuapp.com/api/susaf/topic/all
    responseType: 'json',
    headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-type': 'application/json',
        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
    },
});
